module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tochead",
    attrs: {
      "id": "Contents"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagevii",
      "title": "vii"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocp1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Foreword#Foreword"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Foreword")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Preface#Preface"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Acknowledgments#Acknowledgments"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Maps#Maps"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Maps")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocp12"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Part_One#Part_One"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part One: The French War—The Idea, and Bullets")])])]), _vm._v(" "), _c('h3', {
    staticClass: "tocli"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter01#Chapter01"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("1   ")]), _vm._v("Independence, Union")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocli"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter02#Chapter02"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("2   ")]), _vm._v("Indochina to September 1945")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter03#Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("3   ")]), _vm._v("General Leclerc, October 1945 to June 1946")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter04#Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("4   ")]), _vm._v("Occupation of the North, 1946")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter05#Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("5   ")]), _vm._v("Fontainebleau and All-Out War, July 1946–49")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter06#Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("6   ")]), _vm._v("Huge Battles and Simultaneous Guerrilla Warfare, 1950–mid-1953")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter07#Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("7   ")]), _vm._v("Dien Bien Phu and the End, mid-1953–54")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocp12"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Part_Two#Part_Two",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part Two: The American War—Many More Bullets")])])]), _vm._v(" "), _c('h3', {
    staticClass: "tocli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter08#Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("8   ")]), _vm._v("America in Support, Advisory Mission, 1954–64")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter09#Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("9   ")]), _vm._v("General Westmoreland, Attrition, Search and Destroy, 1964–67")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter10#Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("10   ")]), _vm._v("The Big, Big Unit War, 1967–mid-1968")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter11#Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("11   ")]), _vm._v("General Abrams, “One War,” mid-1968 to Early 1969")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter12#Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("12   ")]), _vm._v("Inside a U.S. Unit at Squadron (Battalion) Level, 1969")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocli"
  }, [_c('span', {
    attrs: {
      "id": "pageviii",
      "title": "viii"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter13#Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("13   ")]), _vm._v("American Withdrawal and Vietnamization, 1969–72")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocp12"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Part_Three#Part_Three",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part Three: The Vietnamese War—The Result")])])]), _vm._v(" "), _c('h3', {
    staticClass: "tocli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter14#Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("14   ")]), _vm._v("A South Vietnamese-North Vietnamese War, 1973–74")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter15#Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("15   ")]), _vm._v("Revolutionary Violence, the Final Act, 1975")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter16#Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("16   ")]), _vm._v("Conclusion: “You Cannot Kill an Idea with Bullets”")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocp1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Endnotes#Endnotes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Endnotes")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Selective_Further_Reading#Selective_Further_Reading",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Selective Further Reading")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ee5fb14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 75
// module chunks = 0